import React, { useContext, useEffect, useState, useMemo } from 'react';
import Swal from 'sweetalert2';

import plataformasContext from '../../context/plataformas/plataformasContext';
import AddItm from '../../components/addItm/AddItm';
import SearchInput from '../../components/searchInput/SearchInput';
import PlataformaRow from '../../components/plataformaRow/PlataformaRow';
import PlataformaForm from '../../components/plataformaForm/PlataformaForm';

import './Plataformas.css';

function Plataformas() {
    const pContext = useContext(plataformasContext);
    const { plataformas, getAllPlataformas, addPlataforma, updatePlataforma, deletePlataforma } = pContext;

    const [filter, setFilter] = useState('');
    const [openForm, setOpenForm] = useState(false);
    const [currentPlataforma, setCurrentPlataforma] = useState(null);

    useEffect(() => {
        getAllPlataformas();
    }, []);

    const handleOpenForm = (plataforma = null) => {
        setCurrentPlataforma(plataforma);
        setOpenForm(true);
    };

    const handleCloseForm = () => {
        setOpenForm(false);
        setCurrentPlataforma(null);
    };

    const handleSave = async (plataformaData) => {
        try {
            if (plataformaData._id) {
                await updatePlataforma(plataformaData);
                Swal.fire('Éxito', 'Plataforma actualizada correctamente', 'success');
            } else {
                await addPlataforma(plataformaData);
                Swal.fire('Éxito', 'Plataforma creada correctamente', 'success');
            }
            handleCloseForm();
            await getAllPlataformas();
        } catch (error) {
            Swal.fire('Error', error.message || 'Error al guardar plataforma', 'error');
        }
    };

    const handleDelete = async (plataforma) => {
        try {
            await deletePlataforma(plataforma);
            Swal.fire('Eliminado', 'Plataforma eliminada correctamente', 'success');
            await getAllPlataformas();
        } catch (error) {
            Swal.fire('Error', error.message || 'Error al eliminar plataforma', 'error');
        }
    };

    const handleSearchInput = (value) => {
        setFilter(value);
    };

    const plataformasFiltered = useMemo(() => {
        if (!plataformas) return [];
        return plataformas.filter(p => {
            if (filter === '') return true;
            const filterLower = filter.toLowerCase();
            return (
                p.codPlataforma?.toLowerCase().includes(filterLower) ||
                p.name?.toLowerCase().includes(filterLower)
            );
        });
    }, [plataformas, filter]);

    if (plataformas === null) {
        return <h3 className="warningStatusMsg">Cargando <span>.</span><span>.</span><span>.</span></h3>;
    }

    return (
        <div className="plataformasList">
            <AddItm titulo={'Plataforma'} anadiritm={handleOpenForm} />
            <SearchInput buscar={handleSearchInput} filter={filter} />

            {plataformasFiltered.length === 0 ? (
                <h3 className="warningStatusMsg">No hay plataformas cargadas</h3>
            ) : (
                plataformasFiltered.map((plataforma) => (
                    <PlataformaRow
                        key={plataforma._id}
                        plataforma={plataforma}
                        onEdit={handleOpenForm}
                        onDelete={handleDelete}
                    />
                ))
            )}

            <PlataformaForm
                open={openForm}
                onClose={handleCloseForm}
                plataforma={currentPlataforma}
                onSave={handleSave}
            />
        </div>
    );
}

export default Plataformas;
